<template>
  <sw-modal :open="showModal" @close="showModal=false">
    <sw-panel class="modal-payment">
      <span
        slot="header"
        class="flex center base-modal-title"
      >{{dictionnary ? dictionnary.infos.paymentTitre : ""}}</span>
      <div class="flex center">
        <sw-avatar
          :size="120"
          src="https://media.giphy.com/media/EX6wKXVM9IOlO/giphy.gif"
          class="avatar"
        />
      </div>
      <div class="flex center base-modal-content">{{content}}</div>
      <sw-button
        class="button-payment-modal center"
        :label="dictionnary ? dictionnary.infos.showPricing : ''"
        @click="go"
      />
    </sw-panel>
  </sw-modal>
</template>
<script>
import { EventBus, PAYMENT_INFO } from '@/model/EventBus'
import { openModal } from '@/model/PixelIOGateway'

import { mapGetters } from 'vuex'
export default {
  name: 'PaymentModal',
  components: {},
  beforeCreate() {},
  async created() {
    EventBus.$on(PAYMENT_INFO, data => {
      if (this.getUpgradeEvent) {
        openModal('myaction', this.getDomain)
        return
      }
      this.showModal = true
      this.content = this.dictionnary[data.type][data.code]
    })
    this.dictionnary = await this.getLanguages
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      showModal: false,
      dictionnary: null,
      content: 'lalalalalalala'
    }
  },
  props: {},
  computed: {
    ...mapGetters(['getLanguages', 'getUpgradeEvent', 'getDomain'])
  },
  methods: {
    go() {
      window.open('https://swello.com/fr/tarifs', '_blank')
    }
  },
  watch: {}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/modal/PaymentModal.vue